// Pinia store replacing Vuex formOrchestration module
import { defineStore } from 'pinia'
import { markRaw } from 'vue'

// Import component references used in orchestrations
import FormPWR1 from '../components/forms/FormPWR1.vue'
import FormPWR2 from '../components/forms/FormPWR2.vue'
import FormPWR3 from '../components/forms/FormPWR3.vue'
import FormPWR4 from '../components/forms/FormPWR4.vue'
import FormPWR5 from '../components/forms/FormPWR5.vue'
import FormULA1 from '../components/forms/FormULA1.vue'
import FormULA2 from '../components/forms/FormULA2.vue'
import FormULA3 from '../components/forms/FormULA3.vue'
import FormULA4 from '../components/forms/FormULA4.vue'
import FormMacPWR from '../components/forms/FormMacPWR.vue'

export const useFormOrchestrationStore = defineStore('formOrchestration', {
  state: () => ({
    currentForm: '',
    currentOrchestration: '',
    orchestrations: [
      {
        name: 'accountClaim',
        initialForm: 'FormPWR1',
        forms: [
          { name: 'FormPWR1', stepText: 'Step 1', step: 1, stepName: 'Lookup Account', component: markRaw(FormPWR1), orchestration: 'passwordReset' },
          { name: 'FormPWR2', stepText: 'Step 2', step: 2, stepName: 'Select a Device', component: markRaw(FormPWR2), orchestration: 'passwordReset' },
          { name: 'FormPWR3', stepText: 'Step 3', step: 3, stepName: 'Validate Security Code', component: markRaw(FormPWR3), orchestration: 'passwordReset' },
          { name: 'FormPWR4', stepText: 'Step 4', step: 4, stepName: 'Set Your New Password', component: markRaw(FormPWR4), orchestration: 'passwordReset' },
          { name: 'FormPWR5', stepText: 'Finish', step: 5, stepName: '', component: markRaw(FormPWR5), orchestration: 'passwordReset' }
        ]
      },
      {
        name: 'passwordReset',
        initialForm: 'FormPWR1',
        forms: [
          { name: 'FormPWR1', stepText: 'Step 1', step: 1, stepName: 'Lookup Account', component: markRaw(FormPWR1), orchestration: 'passwordReset' },
          { name: 'FormPWR2', stepText: 'Step 2', step: 2, stepName: 'Select a Device', component: markRaw(FormPWR2), orchestration: 'passwordReset' },
          { name: 'FormPWR3', stepText: 'Step 3', step: 3, stepName: 'Validate Security Code', component: markRaw(FormPWR3), orchestration: 'passwordReset' },
          { name: 'FormPWR4', stepText: 'Step 4', step: 4, stepName: 'Set Your New Password', component: markRaw(FormPWR4), orchestration: 'passwordReset' },
          { name: 'FormPWR5', stepText: 'Finish', step: 5, stepName: '', component: markRaw(FormPWR5), orchestration: 'passwordReset' }
        ]
      },
      {
        name: 'macPasswordReset',
        initialForm: 'FormMacPWR',
        forms: [
          { name: 'FormMacPWR', stepText: 'Step 1', step: 1, stepName: 'Information', component: markRaw(FormMacPWR), orchestration: 'macPasswordReset' }
        ]
      },
      {
        name: 'unlockAccount',
        initialForm: 'FormULA1',
        forms: [
          { name: 'FormULA1', stepText: 'Step 1', step: 1, stepName: 'Lookup Account', component: markRaw(FormULA1), orchestration: 'unlockAccount' },
          { name: 'FormULA2', stepText: 'Step 2', step: 2, stepName: 'Select a Device', component: markRaw(FormULA2), orchestration: 'unlockAccount' },
          { name: 'FormULA3', stepText: 'Step 3', step: 3, stepName: 'Validate Security Code', component: markRaw(FormULA3), orchestration: 'unlockAccount' },
          { name: 'FormULA4', stepText: 'Finish', step: 4, stepName: '', component: markRaw(FormULA4), orchestration: 'unlockAccount' }
        ]
      }
    ]
  }),
  getters: {
    getOrchestrations: (state) => state.orchestrations,
    getCurrentForm: (state) => state.currentForm,
    getCurrentStep: (state) => {
      const orchestration = state.orchestrations.find(o => o.name === state.currentOrchestration)
      if (orchestration && orchestration.forms) {
        const cur = orchestration.forms.find(f => f.name === state.currentForm)
        return cur ? cur.step : 1
      } else {
        return 1
      }
    }
  },
  actions: {
    updateCurrentForm(formName) {
      this.currentForm = formName
    },
    updateCurrentOrchestration(orchestration) {
      this.currentOrchestration = orchestration
    }
  }
})
